export interface IRevisionDate {
  dueDate: string;
  status: ERevisionDateStatus;
}

export enum ERevisionDateStatus {
  Unset,
  Overdue,
  Close,
  Clear
}